import script from "./WageTaxReq.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageTaxReq.vue?vue&type=script&setup=true&lang=ts"

import "./WageTaxReq.vue?vue&type=style&index=0&id=3cacfed2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cacfed2"]])

export default __exports__